import Router from '../router/Router';

export default function bootstrapHome() {

    const app = document.getElementById('app');

    if (!app) {
        return;
    }

    Router();

}
